import { httpClient } from "../../httpClient";
import { Category } from "../../../store";

type Payload = {
  name: string;
  isActive: boolean;
  isManual: boolean;
  businessUnit: {
    id: number;
    name: string;
  };
};

type Data = any;

export async function getCategories(): Promise<any> {
  try {
    const { data } = await httpClient.get(`/api/v1/system-categories`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getCategoriesByBusinessUnit(
  businessUnit: number
): Promise<any> {
  try {
    const { data } = await httpClient.get(
      `/api/v1/system-categories/bybusiness-unit/${businessUnit}`
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postCategory(payload: Payload): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(
      `/api/v1/system-categories`,
      payload
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function editCategory(
  id: Category["id"],
  payload: Payload
): Promise<boolean> {
  try {
    const response = await httpClient.put(
      `/api/v1/system-categories/${id}`,
      payload
    );

    return response.status === 200;
  } catch (error) {
    throw error;
  }
}

export const category = {
  getCategories,
  getCategoriesByBusinessUnit,
  postCategory,
  editCategory,
};
